/* ========================================
   THE SQUAMISH HAT - THEME JS
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {

  /* ---- SCROLL ANIMATIONS ---- */
  var animateEls = document.querySelectorAll('.tsh-animate');
  if (animateEls.length > 0) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.15 });
    animateEls.forEach(function(el) { observer.observe(el); });
  }

  /* ---- HEADER SCROLL (transparent → solid on homepage) ---- */
  var header = document.querySelector('.tsh-header--transparent');
  var mobileMenuEl = document.querySelector('.tsh-mobile-menu--transparent');
  if (header) {
    var scrollThreshold = 80;
    function updateHeader() {
      if (window.pageYOffset > scrollThreshold) {
        header.classList.add('tsh-header--scrolled');
      } else {
        header.classList.remove('tsh-header--scrolled');
      }
    }
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  /* ---- MOBILE MENU ---- */
  var toggle = document.querySelector('.tsh-header__mobile-toggle');
  var mobileMenu = document.querySelector('.tsh-mobile-menu');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function() {
      var isOpen = mobileMenu.classList.toggle('is-open');
      var icon = toggle.querySelector('svg');
      if (isOpen) {
        icon.innerHTML = '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>';
      } else {
        icon.innerHTML = '<line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="18" x2="21" y2="18"></line>';
      }
    });
    /* Close mobile menu when clicking a link */
    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.classList.remove('is-open');
        var icon = toggle.querySelector('svg');
        icon.innerHTML = '<line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="18" x2="21" y2="18"></line>';
      });
    });
  }

  /* ---- PARALLAX HERO ---- */
  var heroImage = document.querySelector('.tsh-hero__image');
  if (heroImage) {
    window.addEventListener('scroll', function() {
      var scrollY = window.pageYOffset;
      heroImage.style.transform = 'translateY(' + (scrollY * 0.4) + 'px)';
    }, { passive: true });
  }

  /* ---- TYPEWRITER EFFECT ---- */
  var typewriterEl = document.querySelector('[data-typewriter]');
  if (typewriterEl) {
    var text = typewriterEl.getAttribute('data-typewriter');
    var speed = parseInt(typewriterEl.getAttribute('data-typewriter-speed') || '80', 10);
    typewriterEl.textContent = '';
    typewriterEl.style.visibility = 'visible';
    var i = 0;
    function typeChar() {
      if (i < text.length) {
        typewriterEl.textContent += text.charAt(i);
        i++;
        setTimeout(typeChar, speed);
      }
    }
    setTimeout(typeChar, 500);
  }

  /* ---- PRODUCT VARIANT SELECTOR ---- */
  var variantSelects = document.querySelectorAll('.tsh-variant-select');
  var variantIdInput = document.querySelector('input[name="id"]');
  var addToCartBtn = document.querySelector('.tsh-product form button[type="submit"]');
  if (variantSelects.length > 0 && window.TSH_VARIANTS) {
    variantSelects.forEach(function(select) {
      select.addEventListener('change', function() {
        var selectedOptions = [];
        variantSelects.forEach(function(s) { selectedOptions.push(s.value); });
        var match = window.TSH_VARIANTS.find(function(v) {
          return v.options.every(function(opt, idx) { return opt === selectedOptions[idx]; });
        });
        if (match && variantIdInput) {
          variantIdInput.value = match.id;
          if (addToCartBtn) {
            if (match.available) {
              addToCartBtn.textContent = 'Add to Cart';
              addToCartBtn.disabled = false;
            } else {
              addToCartBtn.textContent = 'Sold Out';
              addToCartBtn.disabled = true;
            }
          }
        }
      });
    });
  }

  /* ---- FORM MODAL ---- */
  var openModalBtns = document.querySelectorAll('[data-open-modal]');
  var closeModalBtns = document.querySelectorAll('[data-close-modal]');
  var modalOverlay = document.querySelector('.tsh-modal-overlay');

  openModalBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      if (modalOverlay) {
        modalOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  closeModalBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (modalOverlay) {
        modalOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  });

  if (modalOverlay) {
    modalOverlay.addEventListener('click', function(e) {
      if (e.target === modalOverlay) {
        modalOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---- ESCAPE KEY CLOSES MODAL ---- */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modalOverlay && modalOverlay.classList.contains('is-open')) {
      modalOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

});
